<script>

export default {
  props: ['value'],
  data() {
    return {
      list: [],
    };
  },
  methods: {
    edit() {
      this.$modal.show('edit1');
    },
    beforeClose() {
      this.apply();
    },
    deleteKey(key) {
      this.list = this.list.filter(item => item.key !== key);
    },
    addRow() {
      if (this.list.find(item => item.key === '')) {
        return;
      }
      this.list.push({
        key: '',
      });
    },
    apply() {
      const object = {};
      this.list.forEach(item => {
        object[item.key] = {
          base: parseFloat(item.base),
          mobile: parseFloat(item.mobile),
          pc: parseFloat(item.pc),
        };
      });
      this.$emit('input', object);
    },
    hide() {
      this.$modal.hide('edit1');
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        const list = [];
        for (let i in value) {
          list.push({
            key: i,
            base: value[i].base,
            mobile: value[i].mobile,
            pc: value[i].pc,
          });
        }
        this.list = list;
      },
    },
  },
};
</script>

<template>
  <div>
    <div v-if="list.length > 0">
      <div :key="item.key" v-for="item in list">{{ item.key }}={{ [item.base, item.mobile, item.pc].filter(v => !!v).join('/') }}$</div>
    </div>
    <span v-else>список пуст</span>
    <button class="button" type="button" @click="edit">Редактировать</button>

    <modal name="edit1" @before-close="beforeClose" :scrollable="true" height="auto" class="modal">
      <div class="modal-content">
        <table>
          <thead>
          <tr>
            <th>Страна (ISO Alpha 2)</th>
            <th>Базовая цена ($)</th>
            <th>Цена мобилки ($)</th>
            <th>Цена ПК ($)</th>
            <th>#</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="item.key" v-for="item in list">
            <td><input type="text" v-model="item.key" /></td>
            <td><input type="number" v-model="item.base" min="0" step="0.001"></td>
            <td><input type="number" v-model="item.mobile" min="0" step="0.001"></td>
            <td><input type="number" v-model="item.pc" min="0" step="0.001"></td>
            <td>
              <button type="button" @click="deleteKey(item.key)">Удалить</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="modal-actions">
          <button type="button" @click="addRow()">Новая страна</button>
          <button type="button" @click="hide()">Закрыть</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<style scoped>
.button {
  padding: 2px;
  margin-right: 6px;
}
</style>
